import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactGA from 'react-ga'

import { SettingsStore } from '../../../../store/settings/types'
import { Plann3rStore } from '../../../../store/types'
import { settingsUpdateFirstName,
  settingsUpdateLastName } from '../../../../store/settings/actions'
import Footer from '../../Footer'
import { postUpdateName } from '../../../../api/api'

const NameStep: FC = () => {
  ReactGA.event({
    category: 'Onboarding',
    action: 'Step 3',
  })

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.onboarding.namestep,
  )

  const { first_name, last_name } = useSelector(
    (state: Plann3rStore): SettingsStore => state.settings,
  )

  const dispatch = useDispatch()

  return (
    <div className="onboarding_box">
      <div className="onboarding_content namestep">
        <h2 className="title has-text-centered">{strings.title}</h2>
        <div className="step-description-string">{strings.description}</div>
        <div>
          <div className="columns">
            <div className="column is-6">
              <label>{strings.first_name_label}</label>
              <input
                id="first_name"
                type="text"
                className="grey full-width"
                placeholder={strings.first_name_placeholder}
                value={first_name}
                onChange={(e) => {
                  dispatch(settingsUpdateFirstName(e.target.value))
                }}
                required
              />
            </div>
            <div className="column is-6">
              <label>{strings.last_name_label}</label>
              <input
                id="last_name"
                type="text"
                className="grey full-width"
                placeholder={strings.last_name_placeholder}
                value={last_name}
                onChange={(e) => {
                  dispatch(settingsUpdateLastName(e.target.value))
                }}
                required
              />
            </div>
          </div>
        </div>
      </div>
      <Footer
        next={() => {
          postUpdateName({
            first_name,
            last_name,
          })
        }}
      />
    </div>
  )
}

export default NameStep
